import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleUp } from "@fortawesome/free-regular-svg-icons";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useDispatch } from 'react-redux';
import ChangeThumbnailModalContent from "../dashboard/ChangeThumbnailModalContent";
import { getThumbnailUrlForItem } from "../../utils/common";
import { getItemDetail } from "../../actions/items";

const ReactSwal = withReactContent(Swal);

const ThumbnailEditor = props => {
  const [isHover, setIsHover] = React.useState(false);

  const dispatch = useDispatch();

  const renderThumbnailImage = () => {
    const imageUrl = getThumbnailUrlForItem(props.details);

    if (imageUrl) {
      return <img className="thumbnail-image" src={imageUrl} alt="no thumbnail" />;
    } else {
      return <div className="thumbnail-image no-thumbnail">{_.get(props.details, 'ext', '').toUpperCase()}</div>;
    }
  }

  const onMouseEnter = () => {
    setIsHover(true);
  }

  const onMouseLeave = () => {
    setIsHover(false);
  }

  const openUploadModal = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ChangeThumbnailModalContent
          user={props.user}
          cognitoUser={props.cognitoUser}
          onClose={() => {
            setTimeout(() => {
              dispatch(getItemDetail(_.get(props, 'details.id', '' )));
            }, 4000);
            ReactSwal.clickCancel();
          }}
          file={null}
          Auth={props.Auth}
          Analytics={props.Analytics}
          itemId={_.get(props, 'details.id', '' )}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  return (
    <div
      className="thumbnails relative"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={openUploadModal}
    >
      {isHover && props.isAdmin &&
        <div className="absolute h-full w-full flex items-center justify-center text-white cursor-pointer">
          <FontAwesomeIcon icon={faArrowAltCircleUp} style={{ fontSize: 24 }} />
        </div>
      }
      {/* <img src={_.get(this.props, 'details.thumbnail.ssl_url', '')} alt="thumbnail" /> */}
      {renderThumbnailImage()}
      {/* <div className="d-flex w-100 add-thumbnail">
        <FontAwesomeIcon icon={faCamera} />
        Replace thumbnail...
      </div> */}
    </div>
  )
}

export default ThumbnailEditor;
